export default __webpack_public_path__ + "static/media/dots-bg.de99990d.png";